module.exports = __webpack_public_path__ + "img/4.54eff817.png";